import { createContext, useContext, useState } from "react";
import { useFilter } from "../../../../../hooks/filter";
import { FilterProps } from "../../../../../hooks/filter/typing";
import { useInput } from "../utils";
import { getArea, getDepartments } from "../../../../../utils/methods/geServiceWithItemsFormat";
import { Item } from "../../../../../utils/types/generals";
import { removeAllReference } from "../../../../../utils/methods/removedReference";
import { GeneralConfigContextValue, GetDepartmentWithoutConfigPayload, LoadingConfig, OldData } from "../utils/types";
import { areaServices, departmentService, sharederviceFetch } from "../../../../../utils/constants/callService";
import { formatInputs } from "../utils/format/form";
import { formatConfigFilter } from "../utils/constants/format";

const GeneralConfigContext = createContext<GeneralConfigContextValue>(Object({}))

export const useGeneralConfigContext = () => useContext(GeneralConfigContext)

export const GeneralConfigProvider = ({ children }: { children: JSX.Element }) => {
    const [loadings, setLoadings] = useState<LoadingConfig>({ table: false, editForm: false })
    const [item, setItem] = useState<Record<string, Item[]>>({})
    const { input, setInput } = useInput()
    const inputForm = useInput()
    const [oldData, setOldData] = useState<OldData>()
    const externalValidation: FilterProps['externalValidation'] = ({ name, body, setFilterData }) => {
        let copyBody: Record<string, any> = removeAllReference(body)

        if (name === 'areas') {
            const { areas, departments } = copyBody
            const newDepartments = departments?.filter((e: any) => areas.find((e2: any) => e2.value == e.areaId))
            let arrayChilds: any[] = []

            areas?.forEach((e: any) => {
                const id = e.value
                const childs = item.departments.filter((child) => child.areaId == id)
                arrayChilds.push(...childs)
            })

            setInput(prev => ({ ...prev, departments: { ...prev.departments, items: arrayChilds } }))
            setFilterData((prev) => ({
                ...prev,
                departments: newDepartments,
            }))

            copyBody = {
                ...copyBody,
                departments: newDepartments,
            }
        }

        return copyBody
    }
    const filter = useFilter({ formatFilter: formatConfigFilter, externalValidation })
    const formData = useFilter({
        formatFilter: {}, externalValidation: async (payload) => {
            const { localeBody, } = await formatInputs({ ...payload, getDepartmentsWithoutConfig })
            return localeBody
        }
    })

    const getAreasService = async () => {
        const areas = await getArea()
        setItem((prev) => ({ ...prev, areas, }))
        setInput(prev => ({ ...prev, areas: { ...prev.areas, items: areas } }))
    }
    const getAreasFilterService = async () => {
        const { item } = await areaServices.getfilterArea()
        setItem((prev) => ({ ...prev, areas: item, }))
        inputForm.setInput(prev => ({ ...prev, areas: { ...prev.areas, items: item } }))
    }
    const getDepartmentService = async () => {
        const departments = await getDepartments()
        setItem((prev) => ({ ...prev, departments, }))
    }
    const getDepartmentsWithoutConfig = async ({ areasIds = [], departmentItem }: GetDepartmentWithoutConfigPayload) => {
        const areasIdToString = areasIds.map(area => String(area))
        const response = await departmentService.getDepartmentWithoutConfig({ areasIds: areasIdToString })

        const departmentItems = response.item
        if (!!departmentItem) { departmentItems.push(departmentItem) }
        if (!departmentItem && oldData?.area?.value && areasIdToString.includes(oldData.area.value.toString())) {
            departmentItems.push(oldData.department)
        }

        inputForm.setInput(prev => ({ ...prev, departments: { ...prev.departments, items: departmentItems } }))
        return response
    }

    const getCatalogList = async () => {
        const { item } = await sharederviceFetch.catalogList()
        setInput(prev => ({
            ...prev,
            catalog: { ...prev.catalog, items: item },
        }))
        inputForm.setInput(prev => ({
            ...prev,
            preventiveCatalog: { ...prev.preventiveCatalog, items: item },
            correctiveCatalog: { ...prev.correctiveCatalog, items: item },
        }))
    }
    return (
        <GeneralConfigContext.Provider value={{
            filter,
            input,
            item,
            formData,
            inputForm,
            loadings,
            oldData,
            service: {
                getAreasService,
                getDepartmentService,
                getAreasFilterService,
                getCatalogList,
                getDepartmentsWithoutConfig
            },
            setOldData,
            setItem,
            setInput,
            setLoadings,
        }}>
            {children}
        </GeneralConfigContext.Provider>
    )
}